import { Link } from 'react-router-dom';
import { useEffect, useState } from 'react';
import axios from 'axios'
import {useLang} from "./LangProvider";

function EventList(menuHandler) {

  const [events, setEvents] = useState(null)
  const {t} = useLang()

  useEffect(() => {
    axios
    .get(process.env.REACT_APP_BACKEND_EVENT_LIST,{
      headers:{
        accept:"application/json"
      }
    })
    .then(
      res=>{
        // console.log('event readed', res.data)
        setEvents(res.data)
      }
    )
    .catch(() => {
      setEvents(null)
    })
  },[])

  // return list
  return <> {events ? events.map(event => 
        <Link 
          key={event.id}
          onClick={() => menuHandler()} 
          to={'/event/'+event.id}>
        {t(event.name)} {t(event.city)}
        </Link>
      ): <Link to="#">err:404</Link>}
    </>

}

export default EventList